document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-site-nav-mobile]');
  var menuClose = document.querySelector('[data-menu-close]');
  var menuBackdrop = document.querySelector('[data-menu-backdrop]');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
    if (menuBackdrop) {
      menuBackdrop.hidden = false;
      requestAnimationFrame(function () { menuBackdrop.classList.add('is-open'); });
    }
  }
  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    if (menuBackdrop) {
      menuBackdrop.classList.remove('is-open');
      setTimeout(function () { menuBackdrop.hidden = true; }, 300);
    }
  }
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', function () {
      if (mobileNav.classList.contains('is-open')) closeMobileNav(); else openMobileNav();
    });
  }
  if (menuClose) menuClose.addEventListener('click', closeMobileNav);
  if (menuBackdrop) menuBackdrop.addEventListener('click', closeMobileNav);

  /* ---------- Currency / country selector ---------- */
  var currencyForm = document.querySelector('.currency-form');
  var currencySelect = document.querySelector('[data-currency-select]');
  if (currencyForm && currencySelect) {
    /* Prefix each option with its country's flag, derived from the option's
       own value (the ISO country code already output by Liquid). */
    function flagFor(iso) {
      return String.fromCodePoint.apply(null, iso.split('').map(function (c) { return 127397 + c.charCodeAt(0); }));
    }
    Array.prototype.forEach.call(currencySelect.options, function (opt) {
      opt.textContent = flagFor(opt.value) + ' ' + opt.textContent.trim();
    });

    currencySelect.addEventListener('change', function () {
      currencyForm.submit();
    });

    /* Auto-detect the visitor's country once per browser and switch currency to match,
       if that country is one of the ones set up in Shopify Markets. */
    if (!localStorage.getItem('br_geo_checked')) {
      localStorage.setItem('br_geo_checked', '1');
      fetch('https://ipapi.co/json/')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data || !data.country_code) return;
          var hasMatch = Array.prototype.some.call(currencySelect.options, function (opt) {
            return opt.value === data.country_code;
          });
          if (hasMatch && currencySelect.value !== data.country_code) {
            currencySelect.value = data.country_code;
            currencyForm.submit();
          }
        })
        .catch(function () { /* geolocation lookup unavailable, keep the default currency */ });
    }
  }

  /* ---------- Search panel ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var isOpen = searchPanel.classList.toggle('is-open');
      searchPanel.setAttribute('aria-hidden', !isOpen);
      if (isOpen) {
        var input = searchPanel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartOpeners = document.querySelectorAll('[data-cart-drawer-open]');
  var cartClosers = document.querySelectorAll('[data-cart-drawer-close]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
  }
  cartOpeners.forEach(function (btn) { btn.addEventListener('click', openCartDrawer); });
  cartClosers.forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileNav();
    }
  });

  /* ---------- Quantity steppers (product form + cart) ---------- */
  document.addEventListener('click', function (e) {
    var decrease = e.target.closest('[data-quantity-decrease]');
    var increase = e.target.closest('[data-quantity-increase]');
    if (!decrease && !increase) return;

    var wrapper = (decrease || increase).closest('.quantity-stepper');
    var input = wrapper.querySelector('[data-quantity-input]');
    if (!input) return;

    var value = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 0;

    if (increase) value += 1;
    if (decrease) value = Math.max(min, value - 1);

    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart page: update quantity on change ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-key]');
    if (!input) return;

    var key = input.getAttribute('data-cart-key');
    var quantity = parseInt(input.value, 10) || 0;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function () { window.location.reload(); })
      .catch(function (err) { console.error('Cart update failed', err); });
  });

  /* ---------- Cart drawer / page: remove line ---------- */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    if (!removeBtn) return;

    var key = removeBtn.getAttribute('data-key');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) { return res.json(); })
      .then(function () { window.location.reload(); })
      .catch(function (err) { console.error('Cart remove failed', err); });
  });

  /* ---------- Collection: sort select auto-submits ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      sortSelect.form.submit();
    });
  }

  /* ---------- Product page: gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var mediaId = thumb.getAttribute('data-media-id');
      var gallery = thumb.closest('.product__gallery');
      if (!gallery) return;

      gallery.querySelectorAll('[data-gallery-slide]').forEach(function (slide) {
        slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === mediaId);
      });
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  /* ---------- Product page: variant selection ---------- */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var section = form.closest('[data-product-section]');
    if (!section) return;

    var variantJsonTag = section.querySelector('[data-product-json]');
    if (!variantJsonTag) return;

    var variants;
    try {
      variants = JSON.parse(variantJsonTag.textContent);
    } catch (err) {
      variants = [];
    }

    var selectedOptions = [];
    form.querySelectorAll('[data-option-value].is-selected').forEach(function (btn) {
      selectedOptions[parseInt(btn.getAttribute('data-option-index'), 10)] = btn.getAttribute('data-value');
    });

    function findVariant() {
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null; });
        return opts.every(function (o, i) { return o === selectedOptions[i]; });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      var idInput = form.querySelector('[data-product-variant-id]');
      if (idInput) idInput.value = variant.id;

      var priceEl = section.querySelector('[data-product-price]');
      if (priceEl) {
        var priceHtml = variant.compare_at_price && variant.compare_at_price > variant.price
          ? '<span class="product__price--sale">' + formatMoney(variant.price) + '</span>' +
            '<span class="product__price--compare">' + formatMoney(variant.compare_at_price) + '</span>'
          : formatMoney(variant.price);
        priceEl.innerHTML = priceHtml;
      }

      var addBtn = form.querySelector('[data-add-to-cart]');
      var addText = form.querySelector('[data-add-to-cart-text]');
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    form.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = parseInt(btn.getAttribute('data-option-index'), 10);
        var group = btn.closest('.product-form__swatches');
        if (!group) return;

        group.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');

        var labelSpan = btn.closest('.product-form__option').querySelector('[data-option-selected]');
        if (labelSpan) labelSpan.textContent = btn.getAttribute('data-value');

        selectedOptions[index] = btn.getAttribute('data-value');
        updateForVariant(findVariant());
      });
    });

    /* Sync price / availability with whatever is selected on page load */
    updateForVariant(findVariant());

    /* ---------- Add to cart (AJAX) ---------- */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = form.querySelector('[data-add-to-cart]');
      var addText = form.querySelector('[data-add-to-cart-text]');
      var originalText = addText ? addText.textContent : '';

      if (addText) addText.textContent = 'Adding…';
      if (addBtn) addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: form.querySelector('[data-product-variant-id]').value,
          quantity: parseInt(form.querySelector('[data-quantity-input]').value, 10) || 1
        })
      })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var countEls = document.querySelectorAll('[data-cart-count]');
          countEls.forEach(function (el) { el.textContent = cart.item_count; });
          if (addText) addText.textContent = 'Added';
          openCartDrawer();
          refreshCartDrawer();
          setTimeout(function () {
            if (addText) addText.textContent = originalText;
            if (addBtn) addBtn.disabled = false;
          }, 1200);
        })
        .catch(function (err) {
          console.error('Add to cart failed', err);
          if (addText) addText.textContent = originalText;
          if (addBtn) addBtn.disabled = false;
        });
    });
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCartDrawer() {
    var body = document.querySelector('[data-cart-drawer-body]');
    var subtotalEl = document.querySelector('.cart-drawer__subtotal span:last-child');
    if (!body) return;

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (cart.item_count === 0) {
          body.innerHTML = '<p class="cart-drawer__empty">Your bag is empty.</p>';
        } else {
          body.innerHTML = cart.items.map(function (item) {
            var variantLine = item.variant_title
              ? '<p class="cart-line__variant">' + item.variant_title + '</p>'
              : '';
            var image = item.image
              ? '<img src="' + item.image + '&width=160" alt="" width="80" height="80" loading="lazy">'
              : '';
            return (
              '<div class="cart-line" data-cart-line="' + item.key + '">' +
                '<div class="cart-line__image">' + image + '</div>' +
                '<div class="cart-line__details">' +
                  '<p class="cart-line__title">' + item.product_title + '</p>' +
                  variantLine +
                  '<p class="cart-line__price">' + formatMoney(item.final_line_price) + '</p>' +
                '</div>' +
              '</div>'
            );
          }).join('');
        }
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      })
      .catch(function (err) { console.error('Cart refresh failed', err); });
  }

  /* ---------- Countdown ---------- */
  var countdownEl = document.querySelector('[data-countdown]');
  if (countdownEl) {
    var target = new Date(countdownEl.getAttribute('data-target')).getTime();
    var daysEl = countdownEl.querySelector('[data-countdown-days]');
    var hoursEl = countdownEl.querySelector('[data-countdown-hours]');
    var minutesEl = countdownEl.querySelector('[data-countdown-minutes]');
    var secondsEl = countdownEl.querySelector('[data-countdown-seconds]');

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      var diff = target - Date.now();
      if (isNaN(target) || diff <= 0) {
        daysEl.textContent = '00';
        hoursEl.textContent = '00';
        minutesEl.textContent = '00';
        secondsEl.textContent = '00';
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Product details accordion (boxed dropdown) ---------- */
  document.querySelectorAll('[data-accordion]').forEach(function (accordion) {
    var toggle = accordion.querySelector('[data-accordion-toggle]');
    var panel = accordion.querySelector('[data-accordion-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var isOpen = accordion.classList.toggle('is-open');
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    });
  });

  /* ---------- Product gallery arrow navigation ---------- */
  document.querySelectorAll('.product__gallery').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (!slides.length) return;

    function showSlide(index) {
      var next = (index + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === next); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === next); });
    }

    function currentIndex() {
      return slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(currentIndex() + 1); });

    /* Swipe left/right to change image (touch devices) */
    var touchStartX = null;
    gallery.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        if (dx < 0) showSlide(currentIndex() + 1); else showSlide(currentIndex() - 1);
      }
      touchStartX = null;
    }, { passive: true });
  });

  /* ---------- Mini cart (shown top-right after Quick Add) ---------- */
  var miniCartTimeout;

  function formatMoneyMini(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function getMiniCart() {
    var el = document.querySelector('[data-mini-cart]');
    if (el) return el;

    el = document.createElement('div');
    el.className = 'mini-cart';
    el.setAttribute('data-mini-cart', '');
    el.innerHTML =
      '<div class="mini-cart__header">' +
        '<span>Added to bag</span>' +
        '<button type="button" class="mini-cart__close" data-mini-cart-close aria-label="Close">&times;</button>' +
      '</div>' +
      '<div class="mini-cart__body" data-mini-cart-body></div>' +
      '<div class="mini-cart__footer">' +
        '<button type="button" class="mini-cart__view" data-mini-cart-view>View bag</button>' +
      '</div>';
    document.body.appendChild(el);

    el.querySelector('[data-mini-cart-close]').addEventListener('click', hideMiniCart);
    el.querySelector('[data-mini-cart-view]').addEventListener('click', function () {
      hideMiniCart();
      openCartDrawer();
      refreshCartDrawer();
    });

    return el;
  }

  function hideMiniCart() {
    var el = document.querySelector('[data-mini-cart]');
    if (!el) return;
    el.classList.remove('is-open');
    clearTimeout(miniCartTimeout);
  }

  function showMiniCart(item) {
    var el = getMiniCart();
    var body = el.querySelector('[data-mini-cart-body]');
    var variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<p class="mini-cart__variant">' + item.variant_title + '</p>'
      : '';
    var image = item.image
      ? '<img src="' + item.image + '&width=160" alt="" width="64" height="64" loading="lazy">'
      : '';

    body.innerHTML =
      '<div class="mini-cart__item">' +
        '<div class="mini-cart__image">' + image + '</div>' +
        '<div class="mini-cart__details">' +
          '<p class="mini-cart__title">' + item.product_title + '</p>' +
          variantLine +
          '<p class="mini-cart__price">' + formatMoneyMini(item.final_line_price) + '</p>' +
        '</div>' +
      '</div>';

    requestAnimationFrame(function () { el.classList.add('is-open'); });

    clearTimeout(miniCartTimeout);
    miniCartTimeout = setTimeout(hideMiniCart, 4000);
  }

  /* ---------- Quick add (product cards + homepage stack) ---------- */
  function closeAllQuickAddPanels() {
    document.querySelectorAll('[data-quick-add-panel]').forEach(function (p) { p.hidden = true; });
  }

  function quickAddToCart(btn) {
    var variantId = btn.getAttribute('data-quick-add-variant');
    var originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    var addedItem;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function (item) {
        addedItem = item;
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        btn.textContent = 'Added';
        closeAllQuickAddPanels();
        showMiniCart(addedItem);
        refreshCartDrawer();
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1200);
      })
      .catch(function (err) {
        console.error('Quick add failed', err);
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-quick-add-toggle]');
    if (toggle) {
      e.preventDefault();
      var panel = toggle.closest('[data-quick-add]').querySelector('[data-quick-add-panel]');
      if (!panel) return;
      var willOpen = panel.hidden;
      closeAllQuickAddPanels();
      panel.hidden = !willOpen;
      return;
    }

    var variantBtn = e.target.closest('[data-quick-add-variant]');
    if (variantBtn) {
      e.preventDefault();
      if (variantBtn.disabled) return;
      quickAddToCart(variantBtn);
      return;
    }

    if (!e.target.closest('[data-quick-add]')) {
      closeAllQuickAddPanels();
    }
  });

  /* ---------- Scroll buttons (e.g. hero "Shop the collection") ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-scroll-to]');
    if (!btn) return;
    var target = document.querySelector(btn.getAttribute('data-scroll-to'));
    if (!target) return; // no target on this page: let the link behave normally
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Force-start background videos (Safari sometimes needs a nudge) ---------- */
  document.querySelectorAll('[data-bg-video]').forEach(function (video) {
    var tryPlay = function () {
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* still blocked, native poster stays as fallback */ });
    };
    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadeddata', tryPlay, { once: true });
    }
  });

});
